import undergraduateRouter from './undergraduate'
const routers = [
  // 注册
  {
    path: '/register',
    name: 'register',
    component: () => import('@/view/into/register'),
    children: [
      {
        path: 'em',
        name: 'register-em',
        component: () => import('@/view/into/register-em')
      },
      {
        path: 'smcm',
        name: 'register-smcm',
        component: () => import('@/view/into/register-smcm')
      }
    ]
  },
  // 登陆
  {
    path: '/login',
    name: 'login',
    component: () => import('@/view/into/login')
  },
  // 忘记密码
  {
    path: '/forget',
    name: 'forget',
    component: () => import('@/view/into/forget-pwd1')
  },
  {
    path: '/modify',
    name: 'modify',
    component: () => import('@/view/into/forget-pwd2')
  },
  // 选择类型
  {
    path: '/choose',
    name: 'choose-type',
    component: () => import('@/view/into/choose-type')
  },
  // 主页
  {
    path: '/',
    name: 'home',
    redirect: '/index',
    component: () => import('@/view/home'),
    children: [
      {
        path: 'index',
        name: 'home-index',
        // 页面访问权限
        meta: {
          role: ['SM', 'CM', 'EM']
        },
        component: () => import('@/view/home/home-main')
      },
      // 学生信息页面
      {
        path: 'mentee/:id',
        name: 'mentee-main',
        redirect: {
          name: 'mentee-activities'
        },
        component: () => import('@/view/mentee/main'),
        children: [
          {
            path: 'activities',
            name: 'mentee-activities',
            meta: {
              role: ['SM', 'CM', 'EM']
            },
            component: () => import('@/view/mentee/activities')
          },
          {
            path: 'info',
            name: 'mentee-info',
            redirect: {
              name: 'mentee-info-basic'
            },
            component: () => import('@/view/mentee/info'),
            children: [
              // Basic info
              {
                path: 'basic',
                name: 'mentee-info-basic',
                meta: {
                  role: ['SM', 'CM', 'EM']
                },
                component: () => import('@/view/mentee/info-basic')
              },
              // Educational info
              {
                path: 'education',
                name: 'mentee-info-education',
                meta: {
                  role: ['SM', 'CM', 'EM']
                },
                component: () => import('@/view/mentee/info-education')
              },
              // Test Scores
              {
                path: 'test',
                name: 'mentee-info-test',
                meta: {
                  role: ['SM', 'CM', 'EM']
                },
                component: () => import('@/view/mentee/info-test')
              },
              // Personal experience
              {
                path: 'personal-exp',
                name: 'mentee-info-personal-exp',
                meta: {
                  role: ['SM', 'CM', 'EM']
                },
                component: () => import('@/view/mentee/info-personal-exp')
              },
              // Graduate Study Preference
              {
                path: 'preference',
                name: 'mentee-info-preference',
                meta: {
                  role: ['SM', 'CM', 'EM']
                },
                component: () => import('@/view/mentee/info-preference')
              },
              // Research Plans
              {
                path: 'research',
                name: 'mentee-info-research',
                meta: {
                  role: ['SM', 'CM', 'EM']
                },
                component: () => import('@/view/mentee/info-research')
              },
              // School projects
              {
                path: 'school',
                name: 'mentee-info-school',
                meta: {
                  role: ['SM', 'CM', 'EM']
                },
                component: () => import('@/view/mentee/info-school')
              },
              // Internship experiences
              {
                path: 'internship',
                name: 'mentee-info-internship',
                meta: {
                  role: ['SM', 'CM', 'EM']
                },
                component: () => import('@/view/mentee/info-internship')
              },
              // Extracurricular experience
              {
                path: 'extracurricular',
                name: 'mentee-info-extracurricular',
                meta: {
                  role: ['SM', 'CM', 'EM']
                },
                component: () => import('@/view/mentee/info-extracurricular')
              },
              // Family info
              {
                path: 'family',
                name: 'mentee-info-family',
                meta: {
                  role: ['SM', 'CM', 'EM']
                },
                component: () => import('@/view/mentee/info-family')
              }
            ]
          },
          {
            path: 'appointment',
            name: 'mentee-appointment',
            meta: {
              role: ['SM', 'CM']
            },
            component: () => import('@/view/mentee/appointment')
          },
          {
            path: 'zoom',
            name: 'mentee-zoom',
            meta: {
              role: ['SM', 'CM']
            },
            component: () => import('@/view/mentee/zoom')
          },
          // Program
          {
            path: 'program',
            name: 'mentee-program',
            meta: {
              role: ['SM', 'EM']
            },
            component: () => import('@/view/mentee/program')
          },
          {
            path: 'programs/:programId',
            name: 'mentee-program-main',
            component: () => import('@/view/mentee/program-main'),
            children: [
              {
                path: 'essay-info',
                name: 'mentee-program-essay-info',
                meta: {
                  role: ['SM', 'EM']
                },
                component: () => import('@/view/mentee/program-essay-info')
              },
              {
                path: 'essay-edit',
                name: 'mentee-program-essay-edit',
                meta: {
                  role: ['SM', 'EM']
                },
                component: () => import('@/view/mentee/program-essay-edit')
              },
              {
                path: 'mock',
                name: 'mentee-mock-interview',
                meta: {
                  role: ['SM']
                },
                component: () => import('@/view/mentee/program-mock')
              },
              {
                path: 'mock-zoom',
                name: 'mentee-mock-zoom',
                meta: {
                  role: ['SM']
                },
                component: () => import('@/view/mentee/program-zoom')
              }
            ]
          },
          {
            path: 'cv-rl',
            name: 'mentee-cv-rl',
            meta: {
              role: ['EM']
            },
            component: () => import('@/view/mentee/cv-rl')
          },
          {
            path: 'cv',
            name: 'mentee-cvrl-cv-detail',
            meta: {
              role: ['EM']
            },
            component: () => import('@/view/mentee/cvrl-cv-detail')
          },
          {
            path: 'rl',
            name: 'mentee-cvrl-rl-detail',
            meta: {
              role: ['EM']
            },
            component: () => import('@/view/mentee/cvrl-rl-detail')
          }
        ]
      },
      {
        path: 'materials',
        name: 'materials-main',
        component: () => import('@/view/materials/main')
      },
      // timesheet-penalty
      {
        path: 'timesheet-penalty',
        name: 'timesheet-penalty',
        meta: {
          role: ['SM', 'CM', 'EM']
        },
        component: () => import('@/view/timesheet-penalty'),
        redirect: {
          name: 'timesheet'
        },
        children: [
          {
            path: 'timesheet',
            name: 'timesheet',
            component: () =>
              import('@/view/timesheet-penalty/timesheet/timesheet')
          },
          {
            path: 'penalty',
            name: 'penalty',
            component: () => import('@/view/timesheet-penalty/penalty')
          }
        ]
      },
      {
        path: 'priority',
        name: 'priority',
        meta: {
          role: ['SM', 'EM']
        },
        component: () => import('@/view/edit-priority'),
        redirect: {
          name: 'priority-ddl'
        },
        children: [
          {
            path: 'ddl',
            name: 'priority-ddl',
            component: () => import('@/view/edit-priority/program-ddl')
          },
          {
            path: 'cvrl',
            name: 'priority-cvrl',
            component: () => import('@/view/edit-priority/cvrl-priority')
          },
          {
            path: 'essay',
            name: 'priority-essay',
            component: () => import('@/view/edit-priority/essay-priority')
          }
        ]
      },
      // referral
      {
        path: 'referral',
        name: 'referral',
        redirect: {
          name: 'referral-pay'
        },
        component: () => import('@/view/other/referral'),
        children: [
          {
            path: 'pay',
            name: 'referral-pay',
            meta: {
              role: ['SM', 'CM', 'EM']
            },
            component: () => import('@/view/other/referral-pay')
          },
          {
            path: 'scholarship',
            name: 'referral-scholarship',
            meta: {
              role: ['SM', 'CM', 'EM']
            },
            component: () => import('@/view/other/referral-scholarship')
          }
        ]
      },
      // wechat
      {
        path: 'wechat',
        name: 'wechat',
        component: () => import('@/view/other/wechat')
      },
      // {
      //   path: 'contact',
      //   name: 'contact',
      //   component: () => import('@/view/other/contact')
      // },
      // 个人页面
      {
        path: '/personal',
        name: 'personal',
        redirect: {
          name: 'personal-own'
        },
        component: () => import('@/view/personal/main'),
        children: [
          // 消息页面
          {
            path: 'message',
            name: 'personal-message',
            component: () => import('@/view/personal/message')
          },
          // 个人资料
          {
            path: 'own',
            name: 'personal-own',
            component: () => import('@/view/personal/own')
          },
          // payment
          {
            path: 'payment',
            name: 'personal-payment',
            meta: {
              role: ['SM', 'CM', 'EM']
            },
            component: () => import('@/view/personal/payment')
          },
          // Change password
          {
            path: 'modify',
            name: 'personal-modify-pwd',
            meta: {
              role: ['SM', 'CM', 'EM']
            },
            component: () => import('@/view/personal/modify-pwd')
          }
        ]
      },
      // 申请导师
      {
        path: '/apply',
        name: 'apply',
        redirect: {
          name: 'apply-select'
        },
        component: () => import('@/view/apply/main'),
        children: [
          {
            path: 'banner',
            name: 'apply-banner',
            component: () => import('@/view/apply/banner')
          },
          {
            path: 'detail',
            name: 'apply-detail',
            component: () => import('@/view/apply/detail')
          },
          //  选择导师类型
          {
            path: 'selectType',
            name: 'apply-select',
            component: () => import('@/view/apply/select')
          },
          // 选择导师类型 - EM
          {
            path: 'em',
            name: 'em',
            component: () => import('@/view/apply/em')
          },
          // 选择导师类型 - SM
          {
            path: 'sm',
            name: 'sm',
            component: () => import('@/view/apply/sm')
          },
          // 申请contract提交等待页
          {
            path: ':type',
            name: 'apply-waiting',
            component: () => import('@/view/apply/apply-waiting')
          }
        ]
      },
      // auction
      {
        path: 'auction/:id',
        name: 'auction',
        component: () => import('@/view/auction')
      },
    ]
  },
  ...undergraduateRouter,
  {
    path: '/test',
    name: 'test',
    component: () => import('@/view/test')
  },
  {
    path: '*',
    name: '*',
    component: () => import('@/view/error-page/404')
  }
]
export default routers
